/*
	Create by ljs  2016-01-06
*/
"use strict";
angular.module("productManageMentOrderDeleteModule", [])
    .controller("productManageMentOrderDeleteCtrl", ["$scope", "trsHttpService","deleteItems","$stateParams", "$modalInstance","callback", function($scope, trsHttpService,deleteItems,$stateParams ,$modalInstance,callback) {
       var arrayDeleteitems=[];
	   initData();
        function initData() {
             $scope.lng=deleteItems.length;			
			for(var i=0;i<$scope.lng;i++){
				arrayDeleteitems.push(deleteItems[i].CHANNELID);
			}
			arrayDeleteitems=arrayDeleteitems.toString();
            $scope.datas = $scope.lng>2 ? deleteItems.slice(0,2): deleteItems;	          
        }
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.delete = function() {
			callback(arrayDeleteitems);
            $modalInstance.close();
        };
    }]);
